import {h, Fragment} from "preact"
import { useActions } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import { filterNames } from "../config"

export default function({ facet, checkedFilters, setCheckedFilters }) {
    const { toggleProductFilter } = useActions();
    const [ active, setActive ] = useState(false);

    const selectedFiltersCount = facet.data?.filter(v => v.selected).length ?? 0;

    useEffect(() => {
        if (selectedFiltersCount > 0) {
            setActive(true)
        }
    }, [selectedFiltersCount])

    return (
        <div class={`ns-sidebar-dropdown relative text-left m-0 ${active ? "ns-active" : ""}`}>
            <div class="ns-sidebar-dropdown-header relative overflow-visible p-0">
                <button
                    class="facet-toggle block relative text-left w-full mb-0 pb-0 "
                    data-nosto-element="facet"
                    type="button"
                    label={`Filter product by ${facet.name}`}
                    aria-controls={`nosto-filter-${facet.field}`}
                    aria-expanded={(window.innerWidth > 1110 || active) ? "true" : "false"}
                    tabIndex="0"
                    onClick={() => {
                        setActive(prevActive => !prevActive)
                    }}
                >
                    <span class="block ns-facet-name uppercase leading-6 not-italic font-semibold cursor-pointer">{facet.name}</span>
                </button>
            </div>
            <div class={`ns-sidebar-submenu w-full text-left whitespace-normal p-0 m-0 overflow-hidden lg:block ${active ? "block" : "hidden"}`} id={`nosto-filter-${facet.field}`}>
                <div class="ns-sidebar-submenu-inner w-full mt-3">
                    <ul class="flex flex-col justify-start items-start list-none p-0 m-0">
                        {facet.data?.map(value => {
                            if(value.value === 'Subscription') return;
                            return <li
                                class="ns-facet-li relative p-0 cursor-pointer list-none"
                                data-nosto-element="facet-setting"
                            >
                                <label class="filter-item flex w-full items-center justify-start cursor-pointer">
                                    <input
                                        class="filter-input"
                                        type="checkbox"
                                        checked={
                                            (window.innerWidth < 1110) 
                                                ?   value.selected
                                                :   checkedFilters.some(filter => 
                                                        (filter.facet === facet.field) && 
                                                            (filter.value === value.value) && 
                                                                (filter.selected)
                                                    )
                                        }
                                        onChange={e => {
                                            if(window.innerWidth < 1110) {
                                                e.preventDefault()
                                                toggleProductFilter(
                                                    facet.field,
                                                    value.value,
                                                    !value.selected
                                                )
                                            } else {
                                                e.preventDefault();
                                                const valueIndex = checkedFilters.findIndex(filter => filter.facet === facet.field && filter.value === value.value)
                                                if(valueIndex === -1) {
                                                    const clickedFilter = { facet: facet.field, value: value.value, selected: true }
                                                    setCheckedFilters(prevFilters => [...prevFilters, clickedFilter])
                                                } else {
                                                    const newlyCheckedFilters = [...checkedFilters];
                                                    checkedFilters[valueIndex].selected = !checkedFilters[valueIndex].selected;
                                                    setCheckedFilters(newlyCheckedFilters);
                                                }
                                            }
                                        }}
                                    />
                                    <span class="filter-checkbox relative"></span>
                                    <span class="filter-value">{filterNames[value.value] ? filterNames[value.value] : value.value}</span>
                                </label>
                            </li>
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}
